import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import HtmlText from 'presentation/components/shared/HtmlText/HtmlText';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  description: string;
}

const PeCompanyDescriptionSection: FC<Props> = ({ description }) => {
  const { t } = useTranslation();

  return (
    <>
      <GridHeading>{t('peCompanyDescription')}</GridHeading>
      <AppCard p="20px">
        <HtmlText text={description}/>
      </AppCard>
    </>
  );
};

export default PeCompanyDescriptionSection;
